import { LoginForm } from "@/components/auth/login-form.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/auth/login")({
	component: LoginComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.auth_login_title()) }],
	}),
});

function LoginComponent() {
	return <LoginForm />;
}
